import apiRequest from '../config/api'
export const postRegister = async (data: any) => {
  await apiRequest.getCsrfCookie()

  const res = await apiRequest.post('/api/register', data)
  return res.data
}

export const postLogin = async (data: any) => {
  await apiRequest.getCsrfCookie()

  const res = await apiRequest.post('/api/login', data)
  return res.data
}

export const postPasswordResetLink = async (data: { email: string }) => {
  await apiRequest.getCsrfCookie()

  const res = await apiRequest.post('/api/user/password/reset-link', data)
  return res.data
}

export const postPasswordReset = async (data: {
  token: string
  password: string
  password_confirmation: string
  email: string
}) => {
  await apiRequest.getCsrfCookie()

  const res = await apiRequest.post('/api/user/password/reset', data)
  return res.data
}
